<template>
   <v-container>
      <v-sheet outlined>
         <v-tabs
            height="40"
            v-model="studenttab"
            :slider-color="$globalstore.tab_slidercolor"
            :show-arrows="$vuetify.breakpoint.mobile"
         >
            <v-tab href="#today">Today</v-tab>
            <v-tab href="#group">{{ GroupSubscribeTab }}</v-tab>
            <v-tab href="#fullterm">{{ TermScheduleTab }}</v-tab>
         </v-tabs>
         <v-tabs-items v-model="studenttab">
            <v-tab-item :key="1" value="today">
               <v-col cols="12" md="8">
                  <v-data-table
                     dense
                     :items="student_eventdata"
                     :headers="event_headers"
                     @click:row="todayRowClick"
                     item-key="event_id"
                     hide-default-footer
                     single-select
                     no-data-text="No activity scheduled."
                  >
                     <!-- eslint-disable-next-line -->
                     <template v-slot:item.cca_name="{item}">
                        {{ item.cca_name }}
                        <v-btn
                           x-small
                           outlined
                           color="indigo"
                           @click="showMore(item.cca_description)"
                        >
                           <template>
                              <span class="btn-lower pb-2">...</span>
                           </template>
                        </v-btn>
                     </template>
                  </v-data-table>
               </v-col>
            </v-tab-item>
            <v-tab-item :key="2" value="group">
               <v-row>
                  <v-col cols="12">
                     <template v-if="subgroupdata.length &gt; 0">
                        <v-card class="pa-5">
                           Please note that by subscribing to the following, groups that require
                           consent and/or have fees, will be forwarded to your parent or guardian
                           for approval.
                        </v-card>
                     </template>
                     <template v-else>
                        <v-card class="pa-5">
                           No activities available for subscription.
                        </v-card>
                     </template>
                  </v-col>
               </v-row>
               <v-row align="stretch">
                  <v-col cols="12" class="d-flex flex-column">
                     <v-card
                        class="d-flex flex-column mb-3"
                        outlined
                        v-for="(grp, i) in subgroupdata"
                        :key="i"
                     >
                        <v-row no-gutters align="stretch">
                           <v-col cols="12" md="3" class="d-flex flex-column">
                              <v-card class="flex d-flex flex-column">
                                 <span class="ml-1 font-weight-medium ">
                                    {{ grp.cca_name }}
                                    <template v-if="grp.consent_required">
                                       **
                                    </template>
                                 </span>
                                 <span class="ml-1">
                                    {{ grp.cca_description | ellipsetext(100) }}
                                    <template v-if="grp.cca_description.length > 100">
                                       <v-btn
                                          x-small
                                          outlined
                                          color="indigo"
                                          @click="showMore(grp.cca_description)"
                                          >More</v-btn
                                       >
                                    </template>
                                 </span>
                                 <span class="ml-1"> Fee: {{ grp.cca_fee }} </span>
                              </v-card>
                           </v-col>
                           <v-col cols="12" md="3" class="d-flex flex-column">
                              <v-card class="flex d-flex flex-column">
                                 <div v-for="(evt, j) in grp.eventdata" :key="j">
                                    <span class="ml-1"> Day: {{ evt.daytext }} </span>
                                    <br />
                                    <span class="ml-1"> Time: {{ evt.timetext }} </span>
                                    <br />
                                    <span class="ml-1">
                                       Location:
                                       {{ evt.location_name }}
                                    </span>
                                 </div>
                              </v-card>
                           </v-col>
                           <v-col cols="12" md="2" class="d-flex flex-column">
                              <v-card class="flex d-flex flex-column">
                                 <div>
                                    <span class="ml-1">
                                       Max:
                                       {{ grp.max_participant }} </span
                                    ><br />
                                    <span class="ml-1">
                                       Subscribers:
                                       {{ grp.participantcount }}</span
                                    ><br />
                                    <span class="ml-1">
                                       Waitlist:
                                       {{ grp.waitlistcount }}</span
                                    >
                                 </div>
                              </v-card>
                           </v-col>
                           <v-col cols="12" md="4" class="d-flex flex-column">
                              <v-card class="flex d-flex flex-column">
                                 <v-switch
                                    class="ml-1 my-0"
                                    color="teal darken-1"
                                    :disabled="DisableSubscriptionChange(grp)"
                                    v-model="grp.subscribed"
                                    :label="GetSubscriptionLabel(grp)"
                                    @click="
                                       subscriptionSwitch(
                                          studentlink,
                                          grp.cca_id,
                                          grp.subscribed,
                                          grp,
                                       )
                                    "
                                 >
                                 </v-switch>
                                 <v-switch
                                    class="ml-1 my-0"
                                    color="teal"
                                    :disabled="DisableWaitListChange(grp)"
                                    v-model="grp.waitlisted"
                                    :label="GetWaitListLabel(grp)"
                                    @click="
                                       waitListSwitch(studentlink, grp.cca_id, grp.waitlisted, grp)
                                    "
                                 >
                                 </v-switch>
                                 <label
                                    v-if="grp.consentid && grp.consentstatus == 2"
                                    class="px-2 red darken-1 white--text"
                                    >Last request was rejected</label
                                 >
                              </v-card>
                           </v-col>
                        </v-row>
                     </v-card>
                  </v-col>
               </v-row>
            </v-tab-item>

            <v-tab-item :key="3" value="fullterm">
               <v-col cols="12" md="12">
                  <v-data-table
                     :caption="FullTermCaption"
                     dense
                     :items="termdata"
                     :headers="term_headers"
                     item-key="uniqueid"
                     @click:row="termRowClick"
                     single-select
                  >
                  </v-data-table>
               </v-col>
            </v-tab-item>
         </v-tabs-items>
      </v-sheet>
      <v-dialog v-model="showMoreDlg" max-width="400px">
         <v-card>
            <v-card-title>Description</v-card-title>
            <v-card-text>{{ moredescription }}</v-card-text>
         </v-card>
      </v-dialog>
      <show-toast ref="toast"></show-toast>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </v-container>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import ShowToast from "@/components/showToast.vue";
   import {SubscriptionType} from "@/common/constant.js";

   export default {
      inject: ["ShowMessage"],

      components: {ConfirmDlg, ShowToast},
      data() {
         return {
            studenttab: "today",
            student_eventdata: [],
            subgroupdata: [],
            MAX_CCA: 0,
            subscriptionType: SubscriptionType,

            event_headers: [
               {
                  text: "Name",
                  value: "cca_name",
                  class: this.$globalstore.table_headerclass,
                  width: "40%",
               },
               {
                  text: "Time",
                  value: "timetext",
                  class: this.$globalstore.table_headerclass,
                  width: "20%",
               },
               {
                  text: "Location",
                  value: "location_name",
                  class: this.$globalstore.table_headerclass,
                  width: "40%",
               },
            ],
            termdata: [],
            term_headers: [
               {
                  text: "Day",
                  value: "daytext",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Date",
                  value: "event_date",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Activity",
                  value: "cca_name",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Time",
                  value: "timetext",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  class: this.$globalstore.table_headerclass,
               },
            ],
            studentlink: -1,

            moredescription: "",
            showMoreDlg: false,
         };
      },
      computed: {
         GroupSubscribeTab() {
            return this.$vuetify.breakpoint.mobile ? "Sub Group" : "Subscribe Group";
         },
         TermScheduleTab() {
            return this.$vuetify.breakpoint.mobile ? "Schedule" : "Term Schedule";
         },
         FullTermCaption() {
            return "Full Term Schedule for " + this.$globalstore.user.username;
         },
      },

      methods: {
         showMore(text) {
            this.moredescription = text;
            this.showMoreDlg = true;
         },

         getSubcriptionCount() {
            let count = 0;
            for (let i = 0; i < this.subgroupdata.length; i++) {
               if (this.subgroupdata[i].count_cca == 1) {
                  if (this.subgroupdata[i].subscribed) {
                     count = count + 1;
                  }
               }
            }
            return count;
         },

         DisableSubscriptionChange(grp) {
            if (grp.waitlisted) return true;

            // if invited, need consent, don't allow unsubscribe
            if (grp.subscribed && grp.pcp_subtype == this.subscriptionType.TYPE_INVITATION)
               return true;

            if (
               grp.max_participant > 0 &&
               grp.max_participant == grp.participantcount &&
               !grp.subscribed
            )
               return true;

            // if has consent id, don't allow unsubscribe
            if (grp.pcp_consentid) return true;

            // if has cca tran, don't allow unsubscribe.
            if (grp.ccatran) return true;

            return false;
         },

         GetSubscriptionLabel(grp) {
            if (grp.subscribed) {
               if (grp.ccatran) {
                  if (grp.pcp_consentstatus == 0) {
                     return "Subscribed and pending approval.";
                  } else if (grp.pcp_consentstatus == 1) {
                     if (!grp.ccatran.paid_date) {
                        if (grp.ccatran.invoice_no) {
                           return "Subscribed and invoiced.";
                        } else {
                           return "Subscribed and pending payment.";
                        }
                     } else if (grp.ccatran.paid_date) {
                        return "Subscribed and paid.";
                     }
                  }
               } else if (grp.pcp_consentid) {
                  if (grp.pcp_consentstatus == 1) {
                     return "Subscribed and approved.";
                  } else if (grp.pcp_consentstatus == 0) {
                     return "Subscribed pending approval.";
                  } else {
                     return "Subscribed.";
                  }
               } else {
                  return "Subscribed.";
               }
            } else {
               return "Not Subscribed.";
            }
         },

         DisableWaitListChange(grp) {
            if (grp.subscribed) return true;

            if (grp.waitlisted && (grp.consentstatus == 1 || grp.consentstatus == 2)) return true;

            return false;
         },

         GetWaitListLabel(grp) {
            if (grp.waitlisted) {
               if (grp.wait_consentstatus == 1) {
                  return "On Wait list with approval.";
               } else if (grp.wait_consentstatus == 0) {
                  return "On Wait list pending approval.";
               } else return "On Wait List";
            } else return "Not on Wait List";
         },

         waitListSwitch(schoolid, ccaid, subvalue, grp) {
            this.saveWaitList(schoolid, ccaid, subvalue, grp);
         },

         subscriptionSwitch(schoolid, ccaid, subvalue, grp) {
            if (subvalue) {
               if (grp.count_cca == 1) {
                  let subcount = this.getSubcriptionCount();
                  if (this.MAX_CCA == 0 || (this.MAX_CCA > 0 && subcount <= this.MAX_CCA)) {
                     if (grp.cca_fee > 0) {
                        this.$refs.confirm
                           .open(
                              "Payment",
                              "This activity requires payment to be made for participation. Are you sure you wish to subscribe?",
                              {color: "green", noconfirm: false},
                           )
                           .then((reply) => {
                              if (reply) {
                                 this.saveSubscription(schoolid, ccaid, subvalue);
                                 this.updateGroupStat();
                              } else {
                                 this.revertSubscription(schoolid, ccaid, subvalue);
                              }
                           });
                     } else {
                        this.saveSubscription(schoolid, ccaid, subvalue);
                        this.updateGroupStat();
                     }
                  } else {
                     this.$refs.confirm
                        .open(
                           "Info",
                           "You are limited to a maximum of " +
                              this.$globalstore.appsettings.max_cca_per_student +
                              " activity this term",
                           {
                              color: "primary",
                              noconfirm: true,
                           },
                        )
                        .then((reply) => {
                           this.revertSubscription(schoolid, ccaid, subvalue);
                        });
                  }
               } else {
                  if (grp.cca_fee > 0) {
                     this.$refs.confirm
                        .open(
                           "Payment",
                           "This activity requires payment to be made for participation. Are you sure you wish to subscribe?",
                           {color: "green", noconfirm: false},
                        )
                        .then((reply) => {
                           if (reply) {
                              this.saveSubscription(schoolid, ccaid, subvalue, grp);
                              this.updateGroupStat();
                           } else {
                              this.revertSubscription(schoolid, ccaid, subvalue);
                           }
                        });
                  } else {
                     this.saveSubscription(schoolid, ccaid, subvalue, grp);
                     this.updateGroupStat();
                  }
               }
            } else {
               this.doRemoveSubscription(schoolid, ccaid, subvalue, grp);
            }
         },

         todayRowClick(item, row) {
            row.select(!row.isSelected);
         },

         termRowClick(item, row) {
            row.select(!row.isSelected);
         },

         async saveSubscription(schoolid, ccaid, subvalue) {
            await this.$http({
               url: "/cca/subscribegroup.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  school_id: schoolid,
                  cca_id: ccaid,
                  sub: subvalue,
                  parent: false,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else if (response.data.subscriptionfailed) {
                     this.$refs.confirm
                        .open("Info", response.data.message, {
                           color: "primary",
                           noconfirm: true,
                        })
                        .then((reply) => {
                           this.revertSubscription(schoolid, ccaid, subvalue);
                           this.$refs.toast.display({
                              message: "Subscription failed.",
                              color: this.$globalstore.toast_errorclass,
                           });
                           this.updateGroupStat();
                        });
                  } else if (response.data.conflict) {
                     let cft = this.buildConflictTable(response.data.conflictdata);
                     this.$refs.confirm
                        .open(
                           "Error",
                           "This subscription clashes with your existing subscriptions.<br>" + cft,
                           {color: "red", noconfirm: true},
                        )
                        .then((reply) => {
                           this.revertSubscription(schoolid, ccaid, subvalue);
                           this.$refs.toast.display({
                              message: "Subscription failed.",
                              color: this.$globalstore.toast_errorclass,
                           });
                           this.updateGroupStat();
                        });
                  } else {
                     this.loadAvailableSubGroup();
                     this.$refs.toast.display({
                        message: "Subscription successful.",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         buildConflictTable(data) {
            if (data.length > 0) {
               let cft = "<table>";
               for (let i = 0; i < data.length; i++) {
                  cft += "<tr><td colspan='2' width='100%'>" + data[i].cca_name + "</td></tr>";
                  cft += "<tr><td width='40%'>" + data[i].event_daytext + "</td>";
                  cft += "<td width='60%'>" + data[i].event_time + "</td></tr>";
               }
               cft += "</table>";
               return cft;
            } else {
               return "";
            }
         },

         RemoveSubscription(schoolid, ccaid, subvalue, grp) {
            this.doRemoveSubscription(schoolid, ccaid, subvalue, grp);
         },

         async doRemoveSubscription(schoolid, ccaid, subvalue, grp) {
            await this.$http({
               url: "/cca/unsubscribegroup.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  school_id: schoolid,
                  cca_id: ccaid,
                  unsub: true,
                  consentid: grp.pcp_consentid,
                  consentstatus: grp.pcp_consentstatus,
                  tran_id: grp.ccatran ? grp.ccatran.id : null,
                  parent: false,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else if (response.data.unsubscribefailed) {
                     this.$refs.confirm
                        .open("Info", response.data.message, {
                           color: "primary",
                           noconfirm: true,
                        })
                        .then((reply) => {
                           this.revertSubscription(schoolid, ccaid, subvalue);
                           this.$refs.toast.display({
                              message: "Unsubscribe failed.",
                              color: this.$globalstore.toast_errorclass,
                           });
                           this.updateGroupStat();
                        });
                  } else {
                     this.loadAvailableSubGroup();
                     this.$refs.toast.display({
                        message: "Unsubscribe successful.",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         revertSubscription(schoolid, ccaid, subvalue) {
            for (let i = 0; i < this.subgroupdata.length; i++) {
               if (this.subgroupdata[i].cca_id == ccaid) {
                  this.subgroupdata[i].subscribed = !subvalue;
               }
            }
         },

         // updateSubscription(schoolid, ccaid, subvalue) {
         //    for (let i = 0; i < this.subgroupdata.length; i++) {
         //       if (this.subgroupdata[i].cca_id == ccaid) {
         //          this.subgroupdata[i].subscribed = subvalue;
         //          if (this.subgroupdata[i].consent_required) {
         //             this.subgroupdata[i].consentstatus = subvalue ? 0 : null;
         //          }
         //       }
         //    }
         // },

         // updateWaitList(schoolid, ccaid, subvalue) {
         //    for (let i = 0; i < this.subgroupdata.length; i++) {
         //       if (this.subgroupdata[i].cca_id == ccaid) {
         //          this.subgroupdata[i].waitlisted = subvalue;
         //          if (this.subgroupdata[i].consent_required) {
         //             this.subgroupdata[i].consentstatus = subvalue ? 0 : null;
         //          }
         //       }
         //    }
         // },

         async saveWaitList(schoolid, ccaid, subvalue, grp) {
            await this.$http({
               url: "/cca/subscribewaitlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  school_id: schoolid,
                  cca_id: ccaid,
                  sub: subvalue,
                  consentid: grp.wait_consentid,
                  consentstatus: grp.wait_consentstatus,
                  parent: false,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error || response.data.subscriptionfailed) {
                     this.$refs.confirm
                        .open("Error", response.data.message, {
                           color: "red",
                           noconfirm: true,
                        })
                        .then((reply) => {
                           this.revertSubscription(schoolid, ccaid, subvalue);
                           this.updateGroupStat();
                        });
                  } else {
                     let msg = subvalue
                        ? "Waitlist subscription successful."
                        : "Unsubscribe from Waitlist successful.";
                     this.$refs.toast.display({
                        message: msg,
                        color: this.$globalstore.toast_successclass,
                     });
                     //this.updateWaitList(schoolid, ccaid, subvalue);
                     this.loadAvailableSubGroup();
                     //this.updateGroupStat();
                  }
               }
            });
         },

         getGroupID() {
            let grparray = this.subgroupdata.map((obj) => obj.cca_id);
            return grparray;
         },

         async updateGroupStat() {
            let grparray = this.getGroupID();

            await this.$http({
               url: "/cca/groupsubstats.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  groups: grparray,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     let groupstat = response.data.groupstat;
                     for (let i = 0; i < this.subgroupdata.length; i++) {
                        let index = groupstat.findIndex(
                           (x) => x.cca_id == this.subgroupdata[i].cca_id,
                        );
                        if (index !== -1) {
                           this.subgroupdata[i].participantcount =
                              groupstat[index].participantcount;
                           this.subgroupdata[i].waitlistcount = groupstat[index].waitlistcount;
                        }
                     }
                  }
               }
            });
         },

         async loadStudentTodayList() {
            if (this.studentlink) {
               await this.$http({
                  url: "/cca/getstudenttodaylist.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     school_id: this.studentlink,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.student_eventdata = response.data.eventdata;
                     }
                  }
               });
            }
         },

         async loadAvailableSubGroup() {
            await this.$http({
               url: "/cca/groupsub_bystudent.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  school_id: this.studentlink,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.subgroupdata = response.data.groupdata;
                  }
               }
            });
         },

         async loadFullTerm() {
            await this.$http({
               url: "/cca/getstudentfullterm.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  school_id: this.studentlink,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.termdata = response.data.termdata;
                  }
               }
            });
         },
      },

      async mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.studentlink = this.$globalstore.user.userlinkid;
            this.MAX_CCA = this.$globalstore.appsettings.max_cca_per_student;
            await this.loadStudentTodayList();
            await this.loadAvailableSubGroup();
            await this.loadFullTerm();
         }
      },
   };
</script>

<style scoped>
   .btn-lower {
      text-transform: lowercase;
   }
</style>
